import React, {Component} from "react";
import BilateralDetailLoan from "./BilateralDetailLoanView";
import {BILATERAL_CONTROL_PANEL_ROUTE} from "../../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";
import PropTypes from "prop-types";
import {BilateralLoanService} from "../../../../service/bilateral/loan/BilateralLoanService";

export default class BilateralDetailLoanContainer extends Component {
    constructor(props) {
        super(props);

        this.bilateralLoanService = new BilateralLoanService();
        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.getDetailLoan = this.getDetailLoan.bind(this);

        this.state = {
            isLoading: true,
            loanId: this.props.location.state.selectedLoanControlPanel.id,
            selectedLoan: {},
            collateralDetail: {}
        };
        this.bilateralLoanData = React.createRef();
        this.bilateralCollateralData = React.createRef();
    };

    componentDidMount() {
        let loanId = this.props.location.state.selectedLoanControlPanel.id;
        this.getDetailLoan(loanId);
    }

    getDetailLoan(loanId){
        this.bilateralLoanService.getLoanDetail(loanId, true)
            .then( res => {
                if (this.validResponse(res)){
                    this.setState({
                        selectedLoan: res.data,
                        collateralDetail: res.data.collateralDetail
                    });
                    this.setLoanDetail(res.data);
                    this.setLoanCollateral(res.data.collateralDetail ?? []);
                }
                this.loading(false);
            });
    }

    validResponse (res){
        if (res.status!== 200){
            this.growl.show({severity: 'error', summary: 'Error.',
                detail: res.message  + ' ' + res.debugMessage});
            return false;
        }
        return true;
    }

    setLoanDetail(loanData) {
        this.bilateralLoanData.current.state.selectedLoan = loanData ;
        this.bilateralLoanData.current.getLoan();
    }
    setLoanCollateral(collateralData) {
        this.bilateralCollateralData.current.state.collateralDetail = collateralData;
        this.bilateralCollateralData.current.setCollateralDetail();
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton() {
        this.props.history.push({
            pathname: BILATERAL_CONTROL_PANEL_ROUTE,
        });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <BilateralDetailLoan
            isLoading={this.state.isLoading}
            selectedLoan={this.state.selectedLoan}
            collateralDetail={this.state.collateralDetail}
            messagesGrowl={messagesGrowl}
            loading={this.loading}
            handleReturnButton={this.handleReturnButton}
            bilateralLoanData={this.bilateralLoanData}
            bilateralCollateralData={this.bilateralCollateralData}
        />

    }
};

BilateralDetailLoanContainer.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};